import APIService from './sdk/apiService';
export default class Resource extends APIService{
	constructor(resource){
		super(process.env.REACT_APP_SERVER_URL);
		this.path = resource;
	}
}